import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

import { actions as appActions } from '../reducers/app.reducer';

export const actions = formatActionTypeNames(
	{
		getPage: 'GET_PAGE',
		getPageComplete: 'GET_PAGE_COMPLETE',
		getArticles: 'GET_ARTICLES',
		getArticlesComplete: 'GET_ARTICLES_COMPLETE',
	},
	'PAGES'
);

export const pagesActions = {
	getPage: createAction(actions.getPage),
	getPageComplete: createAction(actions.getPageComplete),
	getArticles: createAction(actions.getArticles),
	getArticlesComplete: createAction(actions.getArticlesComplete),
};

export default (state = initialState.pages, action) => {
	const { payload } = action;
	switch (action.type) {
		case appActions.booted:
			return {
				...state,
				...payload.pages,
			};

		default:
			return state;
	}
};
